// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1whM2","additionalInfo":"AgreementModal_additionalInfo__3lKBo"};